/**
 * External dependencies
 */

import { get } from "lodash";

export default (state) => {
  return get(state, ["currentUser", "username"], "example@email.com");
};
